<template>
    <Header
        :elements="countElements"
        current="4"
    ></Header>
    <div class="MuiBox-root css-3d0ymh">
        <div class="MuiBox-root css-19vwmxk" data-testid="screen-business_details" tabindex="-1">
            <div class="MuiBox-root css-1n2tziu">
                <div class="MuiGrid-root MuiGrid-container css-15zova9 slide-up-enter-done" transition="250">
                    <div class="MuiGrid-root MuiGrid-item MuiGrid-grid-ms-3 MuiGrid-grid-md-4 css-4lvwcn">
                        <div class="MuiBox-root css-1yu9eo3">
                            <div class="MuiGrid-root css-skpbsy">
                                <div class="MuiGrid-root css-vnk25j" type="lottie">
                                    <div>
                                        <Freezeframe
                                            src="/images/free-animated-icon-fast-forward-7740748.gif"
                                        ></Freezeframe>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="MuiGrid-root MuiGrid-item MuiGrid-grid-ms-1 css-se8e58">
                        <div class="MuiBox-root css-8atqhb"></div>
                    </div>
                    <div class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-4 MuiGrid-grid-md-7 css-xjtbym">
                        <Owners
                            :start_owners="owners"
                            $update="owners = $event"
                        ></Owners>
                    </div>
                </div>
            </div>
            <div class="css-1l6i970">
                <div class="css-1c73k7k">
                    <BottomButton
                        :active="true"
                        @click.native="back"
                        text="Back"
                        class_b="button-back"
                    ></BottomButton>
                    <BottomButton
                        :active="true"
                        @click.native="next"
                        text="Next"
                        class_b="button-next"
                    ></BottomButton>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Freezeframe from '@/components/Freezeframe.vue'
import Header from '@/components/Header-Short-New.vue'
import BottomButton from '@/ui/Bottom-Button.vue'
import Owners from '@/components/Owners.vue'
import http from "@/api/http";
import {to_top} from "@/helper";

export default {
    components: {
        Header,
        Owners,
        BottomButton,
        Freezeframe
    },
    data() {
        return {
            owners: [],
            number: '',
            classes: []
        }
    },
    mounted() {
        to_top()
        this.init()
    },
    methods: {
        async init(){
            let { data } = await http.get('trademark-renewal/step-2/'  + this.$route.params.key);

            if (data.res) {
                this.classes = data.data.data.classes
                this.owners = data.data.data.owners
                this.number = data.data.data.number

                this.$store.commit('header/setTotal', data.data.data.total)
            }
        },
        back(){
            this.$router.push({ path: '/trademark-renewal/step-1/' + this.number })
        },
        async next(){
            let { data } = await http.post('trademark-renewal/step-2/'  + this.$route.params.key, {
                owners: this.owners
            });

            if (data.res) {
                let code = this.classes[0]['code']
                this.$router.push({ path: '/trademark-renewal/step-3/' + code + '/' + this.$route.params.key })
            }
        }
    },
    computed: {
        countElements() {
            return this.classes.length ? 6 + (this.classes.length * 2) : 0
        }
    }
}
</script>

